import LogoMark from "./LogoMark";

export default function Footer() {
  return (
    <footer className="bg-[#111113] border-t border-[#2a2a2c] pt-16 pb-8 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div>
            <div className="mb-5">
              <LogoMark size="md" />
            </div>
            <p className="text-[#666] text-sm leading-relaxed">Family-owned towing, transport, and recovery serving Riverside and the Inland Empire since 1991.</p>
          </div>
          <div>
            <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">Services</h4>
            <ul className="space-y-2">
              {["Towing & Transport","Vehicle Recovery","Heavy Equipment Transport","Roadside Assistance","Impound & Storage","Law Enforcement Towing"].map((s) => (
                <li key={s}><a href="#services" className="text-[#666] text-sm hover:text-[#D4AF37] transition-colors cursor-pointer">{s}</a></li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">Coverage</h4>
            <ul className="space-y-2">
              {["Riverside","Moreno Valley","Colton","San Bernardino","Inland Empire","Southern California"].map((c) => (
                <li key={c}><a href="#areas" className="text-[#666] text-sm hover:text-[#D4AF37] transition-colors cursor-pointer">{c}</a></li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold text-sm uppercase tracking-wider mb-4">Contact</h4>
            <div className="space-y-3">
              <a href="tel:9516822003" className="flex items-center gap-2 cursor-pointer group">
                <div className="w-5 h-5 flex items-center justify-center shrink-0">
                  <i className="ri-phone-fill text-[#D4AF37]"></i>
                </div>
                <span className="text-white font-bold text-base group-hover:text-[#D4AF37] transition-colors">(951) 682-2003</span>
              </a>
              <div className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
                  <i className="ri-map-pin-line text-[#D4AF37]"></i>
                </div>
                <span className="text-[#666] text-sm">3777 Placentia Lane<br />Riverside, CA 92501</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center shrink-0">
                  <i className="ri-time-line text-[#D4AF37]"></i>
                </div>
                <span className="text-[#666] text-sm">Open 24/7 — 365 Days</span>
              </div>
            </div>
          </div>
        </div>
        <div className="border-t border-[#2a2a2c] pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-[#555] text-xs">&copy; {new Date().getFullYear()} Exclusive Recovery Inc. All rights reserved.</p>
          <p className="text-[#555] text-xs">DBA Exclusive Towing &bull; Riverside, CA &bull; Licensed &amp; Insured</p>
        </div>
      </div>
    </footer>
  );
}
